var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCableTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4171 0H0.582902C0.260907 0 0 0.26363 0 0.588985V9.77715C0 10.1025 0.260907 10.3661 0.582902 10.3661H5.88917V11.822H4.05443C3.73244 11.822 3.47153 12.0857 3.47153 12.411C3.47153 12.7364 3.73244 13 4.05443 13H10.9456C11.2676 13 11.5285 12.7364 11.5285 12.411C11.5285 12.0857 11.2676 11.822 10.9456 11.822H9.11083V10.3661H14.4171C14.7391 10.3661 15 10.1025 15 9.77715V0.588985C15 0.263708 14.7391 0 14.4171 0ZM7.94503 11.8221H7.05497V10.3661H7.94495L7.94503 11.8221ZM13.8342 9.18817H1.1658V1.17797H13.8342V9.18817Z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableTv);
export default __webpack_public_path__ + "static/media/cable-tv.c800f7fbd2c19b683df55c6c68173069.svg";
export { ForwardRef as ReactComponent };